import { render, staticRenderFns } from "./RiskManagement.vue?vue&type=template&id=2ec7dfb0&scoped=true"
import script from "./RiskManagement.vue?vue&type=script&lang=js"
export * from "./RiskManagement.vue?vue&type=script&lang=js"
import style0 from "./RiskManagement.vue?vue&type=style&index=0&id=2ec7dfb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec7dfb0",
  null
  
)

export default component.exports